<template>
  <div class="index">
    <div class="centered">
      <span class="button-wrapper add-meta-tag" @click="addNewMetaTag">
        <a class="button is-info">+</a>Добавить метатег
      </span>
    </div>
    <div class="meta-tags">
      <MetaTagItem v-for="metaTag in metaTagsData"
      :key="metaTag.id"
      :metaTag="metaTag"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MetaTagItem from 'components/MetaTags/MetaTagItem'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'MetaTags',
  data () {
    return {
      newMetaTags: []
    }
  },
  computed: {
    ...mapState(['metaTags']),
    metaTagsData () {
      return deepcopy(this.metaTags)
    }
  },
  created () {
    this.getMetaTags()
  },
  methods: {
    ...mapActions(['getMetaTags', 'addMetaTagSchema']),
    addNewMetaTag () {
      this.addMetaTagSchema({
        isNew: true,
        url: '',
        title: '',
        description: '',
        keywords: '',
        tempId: uuidv4()
      })
    }
  },
  components: { MetaTagItem }
}
</script>

<style scoped>
.add-meta-tag {
  margin-top: 40px;
}
.meta-tags {
  max-width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Index.vue?73e33e8a